import VideoContainer from '../containers/VideoContainer'
import { decamelizeKeys } from 'humps'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

let guid = 1

export default class VideoClipPlayer extends Component {
  static propTypes = {
    captionSource: PropTypes.string,
    endTime: PropTypes.number,
    height: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    languages: PropTypes.array,
    listeners: PropTypes.object,
    restrictPlaybackToClip: PropTypes.bool,
    src: PropTypes.shape({
      hd: PropTypes.string,
      sd: PropTypes.string
    }).isRequired,
    startTime: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }

  static defaultProps = {
    startTime: 0,
    endTime: 0,
    id: `clipPlayer${guid++}`
  }

  render() {
    const {
      startTime,
      endTime,
      languages,
      restrictPlaybackToClip,
      ...props
    } = this.props

    return (
      <VideoContainer
        {...props}
        controlBar={{
          clipPlaybackButton: {
            startFromClipBeginning: true
          },
          languageMenu: {}
        }}
        plugins={{
          clip: {
            startTime: startTime,
            endTime: endTime,
            restrictPlaybackToClip
          }
        }}
        options={{ languages: decamelizeKeys(languages) }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/VideoClipPlayer.js